import axios from 'axios'

const state = () => ({
  menu: []
})

const getters = {
  menu(state) {
    return state.menu
  }
}

const mutations = {
  SET_MENU(state, payload) {
    state.menu = payload
  },
  DELETE_MENU(state, id) {
    state.menu = state.menu.filter((x) => x.id != id);
  },
  ADD_MENU(state, data) {
    state.menu.push(data)
  },
  UPDATE_MENU(state, payload) {
    state.menu = state.menu.map((x) => {
      if (x.id == payload.id) return payload;
      else return x;
    })
  }
}

const actions = {
  getMenus({ commit }) {
    axios.get('https://api.geomalaka.uz/api/main/menu/')
      .then((res) => {
        commit("SET_MENU", res.data)
        // this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error) => { this._vm.$toast(error.message, {type: 'error'}); })
  },

  deleteMenus({ commit }, id) {
    axios.delete(`https://api.geomalaka.uz/api/main/menu/${id}/`)
      .then((res) => {
        commit("DELETE_MENU", id)
        this._vm.$toast('Deleted', {type: 'success'})
      })
      .catch((error) => { this._vm.$toast(error.message, {type: 'error'}); })
  },

  addMenu({ commit }, payload) {
    axios.post('https://api.geomalaka.uz/api/main/menu/', payload)
      .then((res) => {
        commit("ADD_MENU", res.data)
        this._vm.$toast(res.statusText, {type: 'success'});
      })
      .catch((error) => { this._vm.$toast(error.message, {type: 'error'}); })
  },
  updateMenu({ commit }, payload) {
    axios.put(`https://api.geomalaka.uz/api/main/menu/${payload.id}/`, payload.data)
      .then((res) => {
        commit("UPDATE_MENU", res.data)
        this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error) => { this._vm.$toast(error.message, {type: 'error'}); })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

